import api from '~/util/api';
import type {
  Coupon,
  CouponFormData,
  CouponListParams,
  CouponListResponse,
  CouponValidateParams,
  CouponValidateResponse,
} from '~/types';

const CouponService = {
  list: async (params?: CouponListParams): Promise<CouponListResponse> => {
    const response = await api.get<CouponListResponse>('/coupons', {
      params: {
        page: params?.page ?? 0,
        page_size: params?.page_size ?? 10,
        ...(params?.search?.trim() && { search: params.search.trim() }),
      },
    });
    return response.data;
  },

  create: async (data: CouponFormData): Promise<Coupon> => {
    const response = await api.post<Coupon>('/coupons', {
      code: data.code.trim(),
      description: data.description?.trim() || undefined,
      discount_type: data.discount_type,
      discount_value: data.discount_value,
      is_active: data.is_active,
    });
    return response.data;
  },

  update: async (id: string, data: CouponFormData): Promise<void> => {
    await api.put(`/coupons/${id}`, {
      code: data.code.trim(),
      description: data.description?.trim() || undefined,
      discount_type: data.discount_type,
      discount_value: data.discount_value,
      is_active: data.is_active,
    });
  },

  validate: async (params: CouponValidateParams): Promise<CouponValidateResponse> => {
    const response = await api.post<CouponValidateResponse>('/coupons/validate', {
      code: params.code.trim(),
      cart_total_cents: params.cart_total_cents,
    });
    return response.data;
  },
};

export default CouponService;
